import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";

interface Deal {
  bank_notes?: string;
  internal_notes?: string;
}

interface NotesTabProps {
  formData: Deal;
  onChange: (field: keyof Deal, value: any) => void;
}

export function NotesTab({ formData, onChange }: NotesTabProps) {
  return (
    <div className="space-y-4">
      <div>
        <Label htmlFor="bank_notes">Bank Notes</Label>
        <Textarea
          id="bank_notes"
          value={formData.bank_notes || ''}
          onChange={(e) => onChange('bank_notes', e.target.value)}
          rows={5}
          placeholder="Notes for the bank or underwriter..."
        />
      </div>

      <div>
        <Label htmlFor="internal_notes">Internal Notes</Label>
        <Textarea
          id="internal_notes"
          value={formData.internal_notes || ''}
          onChange={(e) => onChange('internal_notes', e.target.value)}
          rows={5}
          placeholder="Internal notes (not shared externally)..."
        />
      </div>
    </div>
  );
}
